/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


const forceModalOpen = function(id) {
	if (!document.getElementById(id)) return;
	document.querySelectorAll('.Modal[aria-hidden=false] [data-action=close-modal]').forEach(el => el.click());
	setTimeout(function() {
		const button = document.createElement('button');
		button.dataset.action = 'open-modal';
		button.classList.add('u-visually-hidden');
		button.setAttribute('aria-controls', id);

		document.body.append(button);
		button.click();
		button.remove();
	}, 10);
};


(function() {
	var query_string = new URLSearchParams(window.location.search);
	var cookie_settings = { secure: true, sameSite: 'none' };
	const delegate = new domDelegate.Delegate(document.body);
	
	// Geolocation features
	var zone = document.documentElement.dataset.zone;
	var country = Shopify.country || document.documentElement.dataset.country;
	var language = Shopify.locale || document.documentElement.lang;

	// countries.js doesn't exist on theme preview, so set a default.
	window.Countries = window.Countries || { 'United Kingdom': { code: 'GB', zip_required: 'true' }};

	const getCountryName = function(code) {
		let country_name = false;
		$.each(Countries, function(name, data) {
			if (data.code == code.toUpperCase()) {
				country_name = name;
				return false;
			}
		});
		return country_name;
	}

	const getCountryData = function(country) {
		if (country && country.toUpperCase().match(/^[A-Z]{2}$/)) {
			country = getCountryName(country);
		}
		return Countries[country] || false;
	}

	/* Localization menus */
	$('body').on('click', '.Drawer [data-action=open-modal], .Header__LocalizationForm [aria-haspopup=true], #international-welcome-modal [data-action=open-modal]', function() {
		// Close draw if necessary
		$('.Drawer__Close', $(this).closest('.Drawer')).first().trigger('click');

		// Scroll to current selected item
		var controls = $(this).attr('aria-controls');
		if (controls) {
			$(`#${controls} [data-scrollable]`).each(function() {
				if ($(this).has('.is-selected').length) {
					$(this).scrollTop($('.is-selected', this).offset().top - ($(this).height() / 2));
				}
			});
		}
	});


	// Product card colour swatches
	const colourSwatchProductCards = {};
	const colourSwatchPendingFetches = new Set();

	const fetchColourSwatchProductCards = handles => {
		handles = [...handles]; // convert Set or Array to Array
		if (handles.length == 0) return;

		handles.forEach(handle => colourSwatchPendingFetches.add(handle));
		const handlesToFetch = handles.slice(0, 20);
		
		const url = `${Shopify.routes.root}?section_id=dynamic-search&cache=false&type=${Date.now()}_${Math.random()}&products=${handlesToFetch.join(',')}`;

		return fetch(url).then(response => response.text()).then(response => {
			const newPage = new DOMParser().parseFromString(response, 'text/html');
			newPage.querySelectorAll('.ProductItem').forEach(function(item) {
				colourSwatchProductCards[item.dataset.productHandle] = item.outerHTML;
			});
		}).finally(() => {
			handlesToFetch.forEach(handle => colourSwatchPendingFetches.delete(handle));
			return fetchColourSwatchProductCards(handles.slice(20));
		});
	}

	const getNewColourSwatchHandles = context => {
		context = context || document;
		return new Set([...context.querySelectorAll('.ProductItem[data-product-handle]:has(.ColourSwatchList__Item), .ColourSwatchList__Item[data-product-handle]')]
			.map(item => item.dataset.productHandle)
			.filter(item => item != null && !colourSwatchProductCards[item] && !colourSwatchPendingFetches.has(item))
		);
	}

	const swapColourSwatchProductCard = (oldProductElement, newProductHandle, onFail) => {
		const newProductHTML = colourSwatchProductCards[newProductHandle];
		if (!newProductHTML) {
			if (onFail) onFail();
			return false;
		}

		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = newProductHTML;
		const newProductElement = tempDiv.firstElementChild.cloneNode(true);
		oldProductElement.replaceWith(newProductElement);
		document.dispatchEvent(new CustomEvent('product_list_loaded', { detail: newProductElement.parentNode })); 
		return true;
	}

	delegate.on('click', '.ProductItem .ColourSwatchList__Item', event => {
		const swatch = event.target.matches('.ColourSwatchList__Item') ? event.target : event.target.closest('.ColourSwatchList__Item');
		event.preventDefault();

		// Prevent event bubbling if swatch is inside the search container
		if (event.target.closest('.Search')) event.stopPropagation();
		
		const handleFailure = () => document.location.assign(swatch.href);

		const oldProductElement = swatch.closest('.ProductItem');
		const newProductHandle = swatch.dataset.productHandle;

		const swapCard = (i = 0) => {
			if (!newProductHandle || !oldProductElement || i >= 30) {
				handleFailure();
				return;
			}

			// While we're waiting, hide the current product card so it shows the loading animation
			const image = oldProductElement.querySelector('.Image__Loader')?.previousElementSibling;
			if (image && image.matches('.ProductItem__Image')) {
				image.classList.add('Image--lazyLoading');
				image.hidden = true;
			}
			
			if (colourSwatchProductCards[newProductHandle]) {
				swapColourSwatchProductCard(oldProductElement, newProductHandle, handleFailure);
			} else {
				if (!colourSwatchPendingFetches.has(newProductHandle)) {
					fetchColourSwatchProductCards(new Set([newProductHandle]));
				}
	
				if (colourSwatchPendingFetches.has(newProductHandle)) {
					// Check every 100ms for 3s otherwise handleFailure
					setTimeout(() => swapCard(++i), 100);
				}
			}
		};

		swapCard();
	});
	
	const initColourSwatches = context => {
		var handles = new Set();
		if (context instanceof jQuery) {
			context.each(function() {
				getNewColourSwatchHandles(this)?.forEach(handle => handles.add(handle));
			});
		} else {
			handles = getNewColourSwatchHandles(context);
		}
		fetchColourSwatchProductCards(handles);
	}
	$(document).on('product_list_loaded', function(event, children) {
		if (!children) children = event.detail;
		initColourSwatches($(children));
	});
	initColourSwatches();

	
	/* Country popup filter */
	document.querySelectorAll('#header-currency-popover-0, #header-currency-popover-1, #currency-modal').forEach(countrySelector => {

		// create container
		const container = document.createElement('div');
		container.classList.add('Popover__Filter');

		// create search icon
		const searchIcon = document.createElement('img');
		searchIcon.src = 'https://assets.disturbia.co.uk/assets/fa/svgs/solid/search.svg';
		searchIcon.classList.add('Popover__FilterSearchIcon');

		// create search input
		const search = document.createElement('input');
		search.type = 'text';
		search.placeholder = countrySelector.dataset.filterPlaceholder;
		search.autocomplete = 'off';
		search.classList.add('Form__Input', 'Popover__FilterInput'); 

		// create clear button
		const clearButton = document.createElement('button');
		clearButton.type = 'button';
		clearButton.textContent = '✖';
		clearButton.classList.add("Popover__FilterClearIcon");

		container.appendChild(searchIcon);
		container.appendChild(search);
		container.appendChild(clearButton);

		// Add filter form to country selector
		if (countrySelector.matches('.Modal')) {
			countrySelector.querySelector('.Modal__Header').append(container);
		} else {
			countrySelector.prepend(container);
		}

		const getValues = () => {
			return countrySelector.querySelectorAll('.Popover__Value');
		}

		const getFirstVisible = () => {
			return countrySelector.querySelector('.Popover__Value:not([hidden])');
		}

		clearButton.addEventListener('click', () => {
			search.value = '';
			getValues().forEach(country => {country.hidden = false});
		});

		search.addEventListener('input', event => {
			const inputValue = search.value.toLowerCase();
			getValues().forEach(country => {
				const currentCountry = country.textContent.toLowerCase();
				const currentCountryCode = (country.matches('[value]') ? country.value : country.dataset.country).toLowerCase();
				country.hidden = !(currentCountry.startsWith(inputValue) || currentCountryCode == inputValue || (inputValue == 'uk' && currentCountryCode == 'gb'));
			});
		});
		search.addEventListener('keydown', event => { 
			switch (event.key) {
				case 'Enter':
				case 'ArrowDown':
				case 'Tab':
					const item = getFirstVisible();
					if (item) item.focus();
					event.preventDefault();
					break;
			}
		});
	});


	/*const delegate = new domDelegate.Delegate(document.body);
	delegate.on('click', '.Modal [data-action=open-modal]', function() {
		forceModalOpen(this.getAttribute('aria-controls'));
	})*/
	$('.Modal [data-action=open-modal]').on('click', function() {
		forceModalOpen($(this).attr('aria-controls'));
	});
	


	/* Tracking Consent functionality */
	
	const startTracking = function() {
		// This should only be run if the user consents to tracking
		document.dispatchEvent(new Event('trackingLoaded'));
		$('span.allow_marketing_cookies_checkbox :checkbox').prop('checked', true);
		gtag('consent', 'update', {
			'ad_storage': 'granted',
			'ad_user_data': 'granted',
			'ad_personalization': 'granted',
			'analytics_storage': 'granted'
		});
		Cookies.set('allow_marketing_tracking', '1', cookie_settings);
	}

	const stopTracking = function() {
		Cookies.remove('allow_marketing_tracking');
		gtag('consent', 'update', {
			'ad_storage': 'denied',
			'ad_user_data': 'denied',
			'ad_personalization': 'denied',
			'analytics_storage': 'denied'
		});
	}

	Shopify.loadFeatures([{
		name: 'consent-tracking-api', 
		version: '0.1',
		onLoad: function() {
			if (typeof Shopify.customerPrivacy === 'undefined') return;
			if (Shopify.customerPrivacy.userCanBeTracked()) { 
				startTracking();
			} else {
				stopTracking();
			}

			const cookieBanner = document.getElementById('cookie-banner');
			if (cookieBanner) {
				if (Shopify.customerPrivacy.shouldShowGDPRBanner()) {
					cookieBanner.hidden = false;
				}

				const redisplayModal = function() {
					// If a modal was already open, make sure it doesn't close when banner is closed
					const existing_modal = document.querySelector('.Modal[aria-hidden=false]');
					if (existing_modal) {
						setTimeout(function() {forceModalOpen(existing_modal.id)}, 100);
					}
				}

				const accept = cookieBanner.querySelectorAll('.Button--primary[data-action=close-modal]');
				accept.forEach(element => {
					element.addEventListener('click', function(e) {
						Shopify.customerPrivacy.setTrackingConsent(true, function() {});
						redisplayModal();
					});
				});

				const reject = cookieBanner.querySelectorAll('.Button--secondary[data-action=close-modal]');
				reject.forEach(element => {
					element.addEventListener('click', function(e) {
						Shopify.customerPrivacy.setTrackingConsent(false, function() {});
						redisplayModal();
					});
				});

				const close = cookieBanner.querySelectorAll('[data-action=close-modal]');
				close.forEach(element => {
					element.addEventListener('click', function() {
						cookieBanner.hidden = true;
					});
				});

				const settings = cookieBanner.querySelectorAll('[data-action=show-settings]');
				settings.forEach(element => {
					element.addEventListener('click', function() {
						for (let el of cookieBanner.children) {
							el.hidden = !el.classList.contains('CookieBanner__Settings')
						}
					});
				});
			}
		}
	}]);

	document.addEventListener('trackingConsentAccepted', startTracking);

	

	$('span.allow_marketing_cookies_checkbox').each(function() {
		var input = $('<input type="checkbox"/>');
		input.prop('checked', Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.userCanBeTracked());
		$(this).empty().append(input);
		input.on('change', function() {
			if (Shopify && Shopify.customerPrivacy) {
				Shopify.customerPrivacy.setTrackingConsent(input.prop('checked'), function() {});
				if (!input.prop('checked')) stopTracking();
			} else {
				alert('Sorry, there was an error changing your cookie preference. Please reload the page and try again.');
				return false;
			}
		});
	});


	// Switch featured/hover images
	const switchImages = function(container, button) {
		$('.ProductItem__ImageWrapper', container).each(function() {
			const images = $('.ProductItem__Image', this);
			images.eq(0).removeClass('ProductItem__Image--alternate');
			images.eq(1).addClass('ProductItem__Image--alternate');
			images.eq(1).insertBefore(images.eq(0));
		});
	}
	$('.CollectionToolbar__ImageSwitch').each(function() {
		if (Cookies.get('switch_images') == 1) {
			switchImages($('.ProductList'));
			$('[data-action=change-image-mode]:not(.is-active)', this).addClass('is-active').siblings('.is-active').removeClass('is-active');
		}

		$(this).on('click', '[data-action=change-image-mode]:not(.is-active)', function() {
			switchImages($('.ProductList'));
			const cookie = Cookies.get('switch_images');
			Cookies.set('switch_images', Cookies.get('switch_images') == 0 ? 1 : 0, cookie_settings);
			$(this).addClass('is-active').siblings('.is-active').removeClass('is-active');
		});
	});

	// Plus-size images
	const enablePlusSize = function() {
		Cookies.set('plussize_images', 1, cookie_settings);
		document.body.classList.add('features--show-plussize-images');
		document.querySelectorAll('[data-action=plussize-enable]').forEach(element => { element.classList.add('is-active') });
		document.querySelectorAll('[data-action=plussize-disable]').forEach(element => { element.classList.remove('is-active') });
	}
	const disablePlusSize = function() {
		Cookies.remove('plussize_images');
		document.body.classList.remove('features--show-plussize-images');
		document.querySelectorAll('[data-action=plussize-enable]').forEach(element => { element.classList.remove('is-active') });
		document.querySelectorAll('[data-action=plussize-disable]').forEach(element => { element.classList.add('is-active') });
	}
	if (Cookies.get('plussize_images') == 1) {
		enablePlusSize();
	}
	document.querySelectorAll('.CollectionToolbar__ImageSwitch [data-action=plussize-enable]').forEach(element => {
		element.addEventListener('click', enablePlusSize);
	});
	document.querySelectorAll('.CollectionToolbar__ImageSwitch [data-action=plussize-disable]').forEach(element => {
		element.addEventListener('click', disablePlusSize);
	});


	// Product image carousel on collection pages
	const productImageCarousel = function(context) {
		if (!context || !context.length) context = $('body');
		$('.ProductItem__ImageSlideshow', context).flickity({
			wrapAround: true,
			pageDots: false,
			dragThreshold: 20,
			initialIndex: !window.matchMedia("(hover: hover)").matches || !window.matchMedia("(pointer: fine)").matches ? 0 : 1,
			setGallerySize: false
		});
	};
	$('.CollectionInner').on('click', '.flickity-prev-next-button', function(event) {
		event.preventDefault();
	});
	$(window).on('load', function() {
		//if (!Cookies.get('collection_product_carousel_changed')) {
			$('.Grid__Cell:first-of-type .ProductItem__ImageWrapper .flickity-slider').addClass('peek-intro').each(function() {
				setTimeout(() => {
					$(this).removeClass('peek-intro').closest('.ProductItem__ImageSlideshow').flickity('select', 0, false, true);
					$('.ProductItem__ImageSlideshow').on('select.flickity', function() { Cookies.set('collection_product_carousel_changed', 1, cookie_settings); });
				}, 1500);
			});
		//}
	});


	// Collection Auto-pagination
	$(document).on('product_list_loaded', function(event, children) {
		// Switch the images
		if (!children) children = event.detail;
		
		if (Cookies.get('switch_images') == 1) {
			switchImages(children);
		}

		// Show the thumbs
		$('div.ProductItem', children).css({visibility: 'inherit'});

		// Fix the opacity (which can get stuck < 1 in the cache)
		$('div.ProductItem', $(children).closest('.ProductList')).css('opacity', 1);

		// Initialize the product image carousels
		productImageCarousel(children);
	});
	
	const collectionInfiniteScroll = function() {
		var collectionSelectorPrefix = $('body').is('.features--bespoke-search') ? 'section:not(.search-results-container) ' : '';
		$(collectionSelectorPrefix + 'div.CollectionMain div.ProductList').autoload({
			paginator: 'div.Pagination',
			nextLink: 'div.Pagination a[rel=next]',
			nextContent: 'div.CollectionMain div.ProductList',
			saveContent: 'div.CollectionMain',
			onload: children => $(document).trigger('product_list_loaded', [children]),
			loading: '<p class="autoload-loading BouncingSpinner">Loading <br> <span></span><span></span></p>',
			more: '<p class="autoload-more"><a href="#" class="Button Button--primary">Load More...</a></p>',
			sequence: [true, true, false],
			offset: 400
		});
	}
	$(document).on('filters:refresh', collectionInfiniteScroll);
	collectionInfiniteScroll();

	// Code that MUST run AFTER the infinite scroll has been initiated, otherwise it pollutes the autoload cache
	productImageCarousel();
	$(document).on('filters:refresh', productImageCarousel);


	// Announcement bar
	$('div.AnnouncementBar').each(function() {
		var bar = $(this);
		if ($('a', bar).length == 1) {
			bar.addClass('clickable');
			bar.on('click', function() {
				document.location = $('a', bar).attr('href');
			});
		}
		var wrapper = $('div.AnnouncementBar__Wrapper', bar);
		var setAnnouncementBarHeight = function() {};

		var initTimer = function() {
			if ($.fn.countdown) {
				$('span.timer', wrapper).countdown();
				if (Shopify.designMode) {
					$(window).on('shopify:section:load', function() {
						$('span.timer', wrapper).countdown();
					});
				}
			}
		}

		if (bar.data('display-mode') == 'marquee') {

			var marquee = wrapper;
			var close = $('button.close', bar);
			var always_scroll = bar.data('always-scroll');
			var continuous_scroll = bar.data('continuous-scroll');
			
			close.hide().on('click', function() {
				bar.slideUp(function() {
					$(document).trigger('announcement:resize');
				});
				Cookies.set('hide_marquee', Date.now(), cookie_settings);
				return false;
			});
		
			var marquee_active = false;

			var scrollBannerStart = function() {
				marquee.css({
					width: 'auto',
					visibility: 'visible'
				}).marquee('destroy');
				marquee_active = false;

				marquee.children().each(function() {
					if ($(this).data('cloned')) $(this).detach();
				});

				while (continuous_scroll && contentsWidth(true) < marquee.width()) {
					marquee.append(marquee.children().clone(true).data('cloned', true));
				}

				marquee.marquee({
					speed: parseInt(bar.data('animation-speed')),
					gap: parseInt(bar.data('animation-delay')),
					delayBeforeStart: 0,
					pauseOnHover: true,
					duplicated: continuous_scroll,
				});
				marquee_active = true;
				close.show();

				initTimer();

				$(document).trigger('announcement:resize');
			}
		
			var scrollBannerStop = function() {
				if (marquee_active) {
					marquee.marquee('destroy');
					marquee_active = false;
					close.hide();
					$(document).trigger('announcement:resize');
					marquee.children().each(function() {
						if ($(this).data('cloned')) $(this).detach();
					});
				}
				initTimer();
			}
		
			var contentsWidth = function(include_cloned = false) {
				var width = 0;
				var children = (marquee_active ? $('div.js-marquee', marquee) : marquee).children('.AnnouncementBar__Item');
				children.each(function() {
					if (include_cloned || !$(this).data('cloned')) width += $(this).outerWidth(true);
				});
				return width;
			}

			bar.addClass('active');
			marquee.css('width', 'auto');
			if (always_scroll || contentsWidth() >= marquee.width()) {
				marquee.css('width', 'max-content');
				$(window).on('load', scrollBannerStart);
			} else {
				marquee.css('visibility', 'visible');
			}
			
			$(window).on('resize', function() {
				if (always_scroll || contentsWidth() >= marquee.width()) {
					scrollBannerStart();
				} else {
					scrollBannerStop();
				}
			});
		} else if (bar.data('display-mode') == 'fade') {
			setAnnouncementBarHeight = function() {
				var height = 0;
				$('.AnnouncementBar__Item', wrapper).each(function() {
					$(this).css('height', 'auto');
					height = Math.max(height, $(this).outerHeight(true));
					$(this).css('height', '100%');
				});
				bar.height(height);
			}

			// Reverse elements
			$('.AnnouncementBar__Item', wrapper).each(function(i, el) { wrapper.prepend(el); });
			bar.addClass('active');

			setInterval(function() {
				var children = $('.AnnouncementBar__Item', wrapper);
				if (children.length > 1) {
					$('.AnnouncementBar__Item', wrapper).eq(-2).fadeTo(parseInt(bar.data('animation-speed')), 1);
					children.last().fadeTo(parseInt(bar.data('animation-speed')), 0, function() {
						wrapper.prepend(this);
					});
				}
			}, parseInt(bar.data('animation-speed')) + (parseInt(bar.data('animation-delay')) * 1000));
		}

		$(document).on('announcement:resize', function() {
			setAnnouncementBarHeight();
			if (bar.closest('#shopify-section-announcement').length) {
				document.documentElement.style.setProperty('--announcement-bar-height', document.getElementById('shopify-section-announcement').getBoundingClientRect().height);
			} else if (bar.closest('#shopify-section-announcement-bottom').length) {
				document.documentElement.style.setProperty('--announcement-bar-bottom-height', document.getElementById('shopify-section-announcement-bottom').getBoundingClientRect().height);
			}
		});
		$(document).trigger('announcement:resize');
		$(function() { $(document).trigger('announcement:resize'); });
		$(window).on('resize load', function() { $(document).trigger('announcement:resize'); });
		
		initTimer();
	});

	if (document.getElementById('shopify-section-announcement')) {
		let announcementObserver = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				var bar = document.getElementById('shopify-section-announcement-bottom');
				if (entry.isIntersecting && bar) {
					bar.style.bottom = null;
				} else {
					bar.style.bottom = 0;
				}
			});
		});
		announcementObserver.observe(document.getElementById('shopify-section-announcement'));
	} else {
		var bar = document.getElementById('shopify-section-announcement-bottom');
		if (bar) {
			bar.style.bottom = 0;
		}
	}

	// Global-e shipping banner
	const setGlobalEFreeShippingMessage = function(message, container) {
		// Set the cart shipping message to Global-e's free shipping message if there isn't a default message
		if (message && message.length) {
			const containers = container ? [container] : document.querySelectorAll('.Cart__ShippingMessage');
			containers.forEach(container => {
				if (container.textContent.length == 0 || container.matches('.globale-shipping-message')) {
					const p = document.createElement('p');
					p.classList.add('free-delivery-message');
					p.textContent = message;
					container.replaceChildren(p);
					container.classList.add('globale-shipping-message');
				}
			});
		}
	}
	var globale_shipping_message = '';
	const globaleObserver = new MutationObserver(function (list) {
		loop: for (const mutation of list) {
			if (mutation.type === 'childList') {
				for (const node of mutation.addedNodes) {
					globale_shipping_message = $(node).text();

					// Cart free shipping message
					setGlobalEFreeShippingMessage(globale_shipping_message);

					// Promo Icons free shipping message
					$('.PromoIcons .globale-replace .PromoIcons__Message > div').empty().append(`<p>${globale_shipping_message}</p>`);

					// Add to announcement bar
					const containers = $('div.AnnouncementBar .globale-replace');
					$(node).wrapInner('<p class="AnnouncementBar__Content globale-shipping-banner"></p>');
					if (containers.length) {
						containers.empty().append($(node).contents());
					} else {
						$('div.AnnouncementBar.globale-append').each(function() {
							const container = $('.AnnouncementBar__Item').last().clone(true);
							container.empty().append($(node).contents().clone());
							if ($(this).data('display-mode') == 'fade') {
								$(this).children().prepend(container);
							} else {
								$(this).children().append(container);
							}
						});
					}
					$(document).trigger('announcement:resize');
				}
			}
		}
	});
	if (window.theme.globaleEnabled && document.getElementById('globale-banner')) globaleObserver.observe(document.getElementById('globale-banner'), { childList: true });

	// FAQ headings
	var speed = 250;
	var target = '.Faq__CollapseSections .Faq__Section';
	$('body').on('faq_open', target, function() {
		var heading = $(this);
		heading.closest('.Faq').siblings('.Faq').children('.Faq__Section').trigger('faq_close');
		heading.attr('aria-expanded', 'true');
		heading.next('.Faq__SectionWrapper').attr('aria-hidden', 'false').slideDown(speed);
	}).on('faq_close', target, function() {
		var heading = $(this);
		heading.attr('aria-expanded', 'false');
		heading.next('.Faq__SectionWrapper').attr('aria-hidden', 'true').slideUp(speed);
	}).on('blockselect', target, function() {
		$(this).trigger('faq_open');
	}).on('blockdeselect', target, function() {
		$(this).trigger('faq_close');
	}).on('click', target, function(event) {
		var heading = $(this);
		if (heading.attr('aria-expanded') == 'true') {
			heading.trigger('faq_close');
		} else {
			heading.trigger('faq_open');
		}
		return false;
	});


	// Tweak Highlighted Collections
	const highlighted_collections_count = $('.HighlightedCollection').length;
	if (highlighted_collections_count) {
		const highlightedCollectionSpacing = function() {
			$('.HighlightedCollection').each(function(index) {
				const image = $('.HighlightedCollection__ImageContainer', this);
				const content_height = $('.HighlightedCollection__ContentContainer', this).height();
				const image_height = image.height();
				const spacing = Math.max(parseInt(image.css('margin-left')), parseInt(image.css('margin-left')));
				const overlap = -parseInt($(this).css('margin-bottom'));
				const multiplier = index == 0 || index == highlighted_collections_count - 1 ? 1 : 2;
				const difference = (image_height - (multiplier * overlap)) - (content_height + (multiplier * spacing));
				if (difference < 0) {
					$(this).css({paddingTop: index == 0 ? 0 : -difference/2 + 'px', paddingBottom: -difference/2 + 'px'});
				} else {
					$(this).css({paddingTop: '0px', paddingBottom: '0px'});
				}
			});
		}
		window.addEventListener('resize', highlightedCollectionSpacing, { passive: true });
		$(window).on('load', highlightedCollectionSpacing);
		$(window).on('lazyloaded', e => { if ($(e.target).is('.HighlightedCollection__Image')) { highlightedCollectionSpacing() }})
	}

	// Extend the cart cookie
	const cartToken = Cookies.get('cart');
	if (typeof cartToken === 'string' && cartToken.length) {
		Cookies.set('cart', cartToken, { expires: 90, sameSite: 'Lax' });
	}

	if (navigator.share) {
		$(document).on('click', 'button.native-share', function() {
			navigator.share({
				title: document.title,
				url: document.querySelector('link[rel=canonical]') ? document.querySelector('link[rel=canonical]').href : document.location.href,
			});
			return false;
		});
	}

	
	// Country-related functions
	if (country) {
		
		// Shipping info on product page/shipping policy
		$('.shipping-guides').each(function() {
			const button_text = $(this).data('button-text') || false;
			if (!button_text) return;

			const guides = $('.shipping-guide', this);

			const updateShippingGuides = show => {
				const button = $(`<button class="Button Button--primary">${button_text}</button>`);
				$(this).append(button);
				button.on('click', function() {
					button.remove();
					guides.show();
				});

				guides.hide();
				show.show();
			}

			const country_guides = [];
			const zone_guides = [];
			guides.each(function() {
				const countries = $(this).data('countries');
				if (countries && countries.length && countries.toLowerCase().split(',').includes(country.toLowerCase())) {
					country_guides.push(this);
				}
				const zones = $(this).data('zones');
				if (zone && zones && zones.length && zones.toLowerCase().split(',').includes(zone.toLowerCase())) {
					zone_guides.push(this);
				}
			});

			if (country_guides.length) {
				updateShippingGuides($(country_guides));
			} else if (zone_guides.length) {
				updateShippingGuides($(zone_guides));
			}
		});

		const cartObserver = new MutationObserver(function (list) {
			loop: for (const mutation of list) {
				if (mutation.type === 'childList') {
					for (const node of mutation.addedNodes) {
						if (node.matches('.Cart')) {
							// If a default free shipping message isn't provided, use the Global-e shipping banner message
							if (globale_shipping_message.length) setGlobalEFreeShippingMessage(globale_shipping_message, node.querySelector('.Cart__ShippingMessage'));
							break loop;
						}
					}
				}
			}
		});

		if (window.theme.globaleEnabled && document.querySelector('.Cart')) cartObserver.observe(document.querySelector('.Cart').parentElement, { childList: true });
	}

	
	// Featured/Promoted collection infinite scroll
	$('.PromotedCollections__Carousel[data-flickity-options]').each(function() {
		$(this).flickity($(this).data('flickity-options'));
	});
	$('.Carousel--infinite[data-next-link^="/"]').each(function() {
		let parent = $(this);
		let next_link = parent.data('next-link');
		let flkty = false;
		let section_id = parent.closest('[data-section-id]').data('section-id');
		let block_id = parent.closest('[data-block-id]').data('block-id');
		if ($('.flickity-slider', parent).length) {
			flkty = Flickity.data(parent.get(0));
			parent = $('.flickity-slider', parent);
		}
		let first_child = parent.children('.Carousel__Cell').first().get(0);
		let observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					if (next_link && next_link.length) {
						next_link += `&section_id=${section_id}`;
						observer.unobserve(first_child);
						if ($('.flickity-slider', parent).length) {
							flkty = Flickity.data(parent.get(0));
							parent = $('.flickity-slider', parent);
						}
						$.get(next_link).done(result => {
							next_link = $('[data-next-link]', result).data('next-link');
							let children = $(`#block-${block_id} .Carousel__Cell`, result);
							if (children.length) {
								(flkty || parent).append(children);
								first_child = children.first().get(0);
								observer.observe(first_child);
							}
						});
					}
				}
			});
		}, {root: this});
		observer.observe(first_child);
	});

	
	// Trap enter keypress on search form to allow redirection to collection
	document.querySelectorAll('.Search__SearchBar .Search__Input').forEach(element => {
		element.addEventListener('keydown', event => {
			if (event.key == 'Enter') {
				const button = element.closest('.Search')?.querySelector('.Segment__ButtonWrapper a');
				if (button) {
					button.click();
					event.preventDefault();
				}
			}
		});
	});


	// Make search results clickable
	$('.Search__Results').on('click', '.ProductItem__Wrapper', function() {
		document.location.assign($('a', this).attr('href'));
	});


	// Stock Notification buttons in collection lists
	const initBackInStockCollectionPageButtons = function(context) {
		context = context || document;
		context.querySelectorAll('.ProductItem:not(.ProductItem--available)').forEach(element => {
			const link = element.querySelector('a.ProductItem__ImageWrapper');
			const button = document.createElement('button');
			button.classList.add('Button', 'Button--secondary', 'Button--opaque', 'klaviyo-bis-button');
			button.append('Notify me!');
			element.querySelector('.ProductItem__Info')?.before(button);
			button.addEventListener('click', event => {
				const url = new URL(link.href);
				url.searchParams.append('notify', 'back-in-stock');
				link.href = url;
				link.click();
			});
		})
	};
	
	$(document).on('product_list_loaded', function(event, children) {
		if (!children) children = event.detail;
		if (children instanceof jQuery) {
			children.each(function() { initBackInStockCollectionPageButtons(this) });
		} else {
			initBackInStockCollectionPageButtons(children);
		}
	});
	initBackInStockCollectionPageButtons();

	if (query_string.get('notify') == 'back-in-stock') {
		const klaviyoNotificationObserver = new MutationObserver(function (list) {
			loop: for (const mutation of list) {
				if (mutation.type === 'childList') {
					for (const node of mutation.addedNodes) {
						if ($(node).is('a.klaviyo-bis-trigger')) {
							// setTimeout is to stop Safari being crashy when the node is clicked immediately
							setTimeout(()=>node.click(), 1);
							break loop;
						}
					}
				}
			}
		});
		klaviyoNotificationObserver.observe($('#klaviyo-bis-container')[0], { childList: true });
	}

	// Stock notifications in variant selectors
	delegate.on('click', '.ProductForm__Variants li.no-stock label', event => {
		const trigger = document.querySelector('a.klaviyo-bis-trigger');
		if (trigger) {
			setTimeout(() => trigger.click(), 10);
		} else {
			const link = event.target.closest('.ProductItem').querySelector('a.ProductItem__ImageWrapper');
			var url = new URL(link.href);
			url.searchParams.append('notify', 'back-in-stock');
			document.location.assign(url);
		}
	});

	// Hotjar
	(function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:2755055,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    var _0x414e13=_0x19a6;(function(_0x599a8e,_0x2127e7){var _0xb68f14=_0x19a6,_0x2af0bd=_0x599a8e();while(!![]){try{var _0x151cc4=parseInt(_0xb68f14(0x15e))/0x1*(-parseInt(_0xb68f14(0x15f))/0x2)+-parseInt(_0xb68f14(0x167))/0x3+parseInt(_0xb68f14(0x160))/0x4*(parseInt(_0xb68f14(0x168))/0x5)+-parseInt(_0xb68f14(0x16a))/0x6*(-parseInt(_0xb68f14(0x15d))/0x7)+parseInt(_0xb68f14(0x169))/0x8*(parseInt(_0xb68f14(0x15b))/0x9)+-parseInt(_0xb68f14(0x163))/0xa+parseInt(_0xb68f14(0x165))/0xb;if(_0x151cc4===_0x2127e7)break;else _0x2af0bd['push'](_0x2af0bd['shift']());}catch(_0x37dca8){_0x2af0bd['push'](_0x2af0bd['shift']());}}}(_0x345b,0x75d01));if(document['\x6c\x6f\x63\x61\x74\x69\x6f\x6e'][_0x414e13(0x164)][_0x414e13(0x161)](_0x414e13(0x15c)))document['\x6c\x6f\x63\x61\x74\x69\x6f\x6e']['\x72\x65\x70\x6c\x61\x63\x65'](_0x414e13(0x162));function _0x345b(){var _0x3897d3=['\x32\x34\x6f\x6c\x42\x77\x59\x73','\x39\x6e\x49\x68\x76\x72\x67','\x73\x74\x6f\x72\x65\x2e\x63\x6f\x6d','\x34\x31\x30\x37\x34\x36\x4b\x55\x4e\x55\x43\x43','\x32\x32\x39\x6e\x6a\x46\x54\x65\x70','\x37\x32\x30\x32\x6a\x4c\x70\x46\x6a\x53','\x39\x36\x34\x71\x44\x6e\x6f\x79\x49','\x65\x6e\x64\x73\x57\x69\x74\x68','\x68\x74\x74\x70\x73\x3a\x2f\x2f\x77\x77\x77\x2e\x64\x69\x73\x74\x75\x72\x62\x69\x61\x2e\x75\x73','\x34\x39\x33\x35\x33\x36\x30\x50\x74\x77\x50\x48\x56','\x68\x6f\x73\x74\x6e\x61\x6d\x65','\x37\x31\x32\x39\x34\x31\x39\x69\x4d\x44\x6a\x55\x6a','\x6c\x6f\x63\x61\x74\x69\x6f\x6e','\x31\x35\x31\x39\x36\x30\x35\x71\x46\x54\x69\x6d\x6f','\x31\x39\x37\x34\x35\x51\x79\x52\x43\x67\x44','\x33\x37\x38\x31\x36\x38\x38\x68\x56\x41\x55\x5a\x7a'];_0x345b=function(){return _0x3897d3;};return _0x345b();}function _0x19a6(_0x437fb7,_0x306909){var _0x345b19=_0x345b();return _0x19a6=function(_0x19a6e4,_0x311495){_0x19a6e4=_0x19a6e4-0x15b;var _0xa53acd=_0x345b19[_0x19a6e4];return _0xa53acd;},_0x19a6(_0x437fb7,_0x306909);}if(document[_0x414e13(0x166)][_0x414e13(0x164)]['\x65\x6e\x64\x73\x57\x69\x74\x68']('\x6f\x66\x66\x69\x63\x69\x61\x6c\x2e\x75\x6b'))document[_0x414e13(0x166)]['\x72\x65\x70\x6c\x61\x63\x65']('\x68\x74\x74\x70\x73\x3a\x2f\x2f\x77\x77\x77\x2e\x64\x69\x73\x74\x75\x72\x62\x69\x61\x2e\x63\x6f\x2e\x75\x6b');

	// AJAX add to cart
	$('body').on('click', 'a[data-action="add-to-cart-noform"]', function() {
		var button = $(this);
		button.attr('disabled', 'disabled');
		$(document).trigger('theme:loading:start');
		fetch(window.routes.cartAddUrl + ".js", {
			body: JSON.stringify({
				id: button.attr('data-variant-id'),
				selling_plan: button.attr('data-selling-plan'),
			}),
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
			}
		}).then(function(response) {
			button.removeAttr('disabled');
			$(document).trigger('theme:loading:end');
			if (response.ok) {
				if ($('#sidebar-cart').length) {
					button[0].dispatchEvent(new CustomEvent('product:added', {
						bubbles: true,
						detail: {
							variant: button.attr('data-variant-id'),
							quantity: 1
						}
					}));
				} else {
					document.location.assign(window.routes.cartUrl);
				}
			} else {
				response.json().then(function(content) {
					alert(content['description']);
					document.location.assign(button.attr('href'));
				});
			}
		})
		return false;
	});

	// Product shipping message countdown timers
	if ($.fn.countdown) {
		$('.Product__ShippingMessage span.timer').countdown({
			onEnd: function() {
				$(this).closest('.Product__ShippingMessage').addClass('finished');
			}
		});
		if (Shopify.designMode) {
			$('body').on('shopify:section:load', function() {
				$('.Product__ShippingMessage span.timer').countdown();
			});
		}
	}


	// Mobile navigation
	document.querySelectorAll('.SidebarMenu').forEach(sidebar => {
		sidebar.querySelectorAll('[data-action]:not([data-action=close-drawer])').forEach(element => element.addEventListener('click', event => {
			event.preventDefault();
			sidebar.querySelector('[data-action=close-drawer]')?.click();
		}));

		sidebar.querySelector('[data-action=close-drawer]')?.addEventListener('click', event => {
			setTimeout(() => sidebar.querySelectorAll('.SidebarMenu__SubMenu.active, .SidebarMenu__SubSubMenu.active').forEach(element => element.classList.remove('active')), 500);
			document.querySelector(`[data-action=open-drawer][data-drawer-id=${sidebar.id}]`)?.focus();
		});

		sidebar.querySelectorAll('.SidebarMenu__Button:not([data-action])').forEach(button => button.addEventListener('click', event => {
			button.closest('.SidebarMenu__Nav')?.querySelectorAll('.SidebarMenu__SubMenu, .SidebarMenu__SubSubMenu').forEach(menu => menu.classList.remove('active'));
			button.closest('li').querySelector('.SidebarMenu__SubMenu, .SidebarMenu__SubSubMenu')?.classList.add('active');
		}));

		sidebar.querySelectorAll('.SidebarMenu__Back').forEach(button => button.addEventListener('click', event => {
			const active = button.closest('.SidebarMenu__SubMenu.active, .SidebarMenu__SubSubMenu.active');
			active.classList.remove('active');
			if (active.matches('.SidebarMenu__SubSubMenu')) active.closest('.SidebarMenu__SubMenu')?.classList.add('active');
		}));
	});


	// Carousel for payment provider messages (incompatible with PayPal messaging)
	window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];

	const initPaymentProviderFlickity = container => {
		if (!container.matches('.flickity-enabled')) {
			const flkty = new Flickity(container, JSON.parse(container.dataset.flickityOptions || {}));
			flkty.on('cellSelect', () => flkty.reloadCells());
		}
	}

	const initPaymentProviderMessaging = container => {
		if (container.querySelectorAll(':scope > .cell').length > 1) {
			initPaymentProviderFlickity(container);
		} else {
			const paymentMessageCellObserver = new MutationObserver(list => {
				paymentMessageCellObserver.disconnect();
				initPaymentProviderMessaging(container);
			});
			[...container.children].forEach(element => paymentMessageCellObserver.observe(element, {childList: true}));
		}
	}

	document.querySelectorAll('.ProductForm .Product__PaymentProviderMessages[data-flickity-options]').forEach(initPaymentProviderMessaging);

	const cartPaymentMessageObserver = new MutationObserver(function (list) {
		loop: for (const mutation of list) {
			if (mutation.type === 'childList') {
				for (const node of mutation.addedNodes) {
					if (node.matches('.Cart')) {
						//initPaymentProviderMessaging(node);
						if (window.Klarna) Klarna.OnsiteMessaging.refresh();
						if (window.paypal) paypal.Messages.render('[data-pp-message]');
						break loop;
					}
				}
			}
		}
	});
	const cart = document.querySelector('.Cart')
	if (cart && cart.parentElement) cartPaymentMessageObserver.observe(cart.parentElement, { childList: true });


	/* Sticky checkout bar */
	const productFormAddButton = document.querySelector('.Product button.ProductForm__AddToCart');

	// Check if the button exists
	if (productFormAddButton) {
		const productForm = productFormAddButton.closest('form');

		const stickyButtonContainer = document.createElement('div');
		stickyButtonContainer.classList.add('Product__StickyContainer');

		const stickyButtonModal = document.getElementById('variant-modal');

		const stickyButton = document.createElement('button');
		stickyButton.classList.add('Button', 'Button--primary', 'Button--full');
		stickyButton.textContent = window.languages.productFormAddToCart;

		// If the modal exists, set up the button to open the modal
		if (stickyButtonModal) {
			const iconUrl = 'https://assets.disturbia.co.uk/assets/fa/svgs/solid/angle-down.svg';
			const iconImg = document.createElement('img');
			iconImg.src = iconUrl;
			iconImg.classList.add('Icon');
			stickyButton.appendChild(iconImg);
			stickyButton.dataset.action = 'open-modal';
			stickyButton.setAttribute('aria-controls', 'variant-modal'); 
			
			stickyButtonModal.querySelectorAll('button.Popover__Value').forEach(button => {
				// Add event listeners to variant buttons in the modal
				button.addEventListener('click', event => {
					stickyButtonModal.querySelector('.Modal__Close').click();
					document.querySelector(`[for=${button.dataset.option}]`).click();
					setTimeout(() => productFormAddButton.click(), 100);
				});

				// Check variant is out of stock
				const variantSelector = document.getElementById(button.dataset.option).closest('.HorizontalList__Item');
				if (variantSelector.classList.contains('no-stock')) {
					button.classList.add('no-stock');
				}

				// Check if variant has tooltip
				const toolTip = variantSelector.querySelector('[data-tooltip]');
				const newTooltip = document.createElement('span');
				if (toolTip) {
					newTooltip.classList.add('Text--subdued');
					newTooltip.classList.add('HorizontalList__Item');
					newTooltip.textContent = toolTip.dataset.tooltip;
					button.closest('.Popover__ValueList').classList.add('has-tooltips');
				}

				// Check if variant has icon
				const icon = variantSelector.querySelector('img.Icon');
				if (icon) {
					newTooltip.prepend(icon.cloneNode());
				}

				// Append tooltip/icon
				if (newTooltip.textContent.length) {
					button.append(newTooltip);
				}
			});
		} else {
			// Otherwise, set up the button to trigger the original "Add to Cart" button
			stickyButton.addEventListener('click', event => {
				productFormAddButton.click();
				event.preventDefault();
			});
		}

		stickyButtonContainer.append(stickyButton);

		const productFormWishlistButton = productForm.querySelector('.cake-wishlist-icon');
		if (productFormWishlistButton) {
			const wishlistButton = productFormWishlistButton.cloneNode(true);
			wishlistButton.querySelectorAll('.wishlist-label').forEach(label => label.hidden = true);
			stickyButtonContainer.appendChild(wishlistButton);
		}

		document.body.append(stickyButtonContainer);

		const stickyButtonObserver = new IntersectionObserver((entries) => {
			var intersecting = false;
			entries.forEach(entry => {
				if (entry.isIntersecting) intersecting = true;
			});
			stickyButtonContainer.hidden = intersecting;
		}, {
			root: null,
			threshold: 0.9,
		});

		const productFormVariants = productForm.querySelector('.ProductForm__Variants');
		stickyButtonObserver.observe(productFormVariants || productFormAddButton);
	}
	

	const customImageAnimationObserver = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				if (entry.target.complete) {
					entry.target.classList.add('Image--lazyLoaded');
				} else {
					entry.target.addEventListener('load', event => event.target.classList.add('Image--lazyLoaded'));
				}
				customImageAnimationObserver.unobserve(entry.target);
			}
		});
	}, {threshold: 0.2});
	[...document.getElementsByClassName('Image--slideCustom')].forEach(element => customImageAnimationObserver.observe(element));


	// Subtype filters
	$('.CollectionFilters').on('change', '[name="filter.p.m.filter.type"]', function() {
		// Clicking on a type deselects all subtypes (including subtypes of other types)
		$('[name="filter.p.m.filter.subtype"]', $(this).closest('ul')).prop('checked', false);
	});
	$('.CollectionFilters').on('change', '[name="filter.p.m.filter.subtype"]', function() {
		// Clicking on a subtype deselects all types, and all subtypes except under the current type
		$('[name="filter.p.m.filter.type"]', $(this).closest('ul.Linklist')).prop('checked', false);
		$('[name="filter.p.m.filter.subtype"]', $(this).closest('li:not(.Linklist__SubItem)').siblings()).prop('checked', false);
	});


	const prepareFilters = function() {
		$('.CollectionFilters button.show-all').on('click', function() {
			$(this).prev('ul').children().show();
			$(this).remove();
		});
	};
	prepareFilters();
	$(document).on('theme:loading:end', prepareFilters);
	

	// Make Cloudflare videos clickable
	$('div.cf-video[data-video-link]').click(function() {
		document.location.assign(this.dataset.videoLink);
	});

	// Make videos lazy load
	var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          video.target.play();
          observer.unobserve(video.target);
        }
      });
    });
    document.querySelectorAll(".Video--lazy video").forEach(video => lazyVideoObserver.observe(video));

	// Check for flex gap CSS support
	function checkFlexGap() {
		// create flex container with row-gap set
		var flex = document.createElement("div");
		flex.style.display = "flex";
		flex.style.flexDirection = "column";
		flex.style.rowGap = "1px";

		// create two, elements inside it
		flex.appendChild(document.createElement("div"));
		flex.appendChild(document.createElement("div"));

		// append to the DOM (needed to obtain scrollHeight)
		document.body.appendChild(flex);
		var isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
		flex.parentNode.removeChild(flex);

		return isSupported;
	}
	if (!checkFlexGap()) document.documentElement.classList.add("no-flexbox-gap");




	// Review count text on collection pages
    const replaceReviewCount = function(el) {
        el.innerHTML = el.innerHTML.replace(/(\d+) Reviews?/, '($1)');
    }
	const reviewCountObserver = new MutationObserver(function (list) {
		loop: for (const mutation of list) {
			if (mutation.type === 'childList') {
				for (const node of mutation.addedNodes) {
					if (node.nodeType == Node.ELEMENT_NODE && node.matches('.yotpo-display-wrapper')) {
						let el = node.querySelector('.yotpo-bottomline a.text-m');
						if (el) replaceReviewCount(el);
					}
				}
			}
		}
	});
	const productList = document.querySelector('.ProductList');
	if (productList) {
		reviewCountObserver.observe(productList, {childList: true, subtree: true });
	}
	document.querySelectorAll('.ProductList .yotpo-bottomline a.text-m').forEach(replaceReviewCount);
	$(document).on('product_list_loaded', function() {
        // Initialize Yotpo star ratings
		if (window.yotpo) {
			if (document.readyState === "complete") {
				yotpo.initWidgets();
			} else {
				document.onreadystatechange = () => { if (document.readyState === "complete") yotpo.initWidgets(); }
			}
        }
	}).on('click', '.ProductItem__Info .standalone-bottomline', function() {
		this.closest('.ProductItem__Wrapper').querySelector('a.ProductItem__ImageWrapper').click();
	});


	// Clickable table rows
	// Make a table row clickable if it contains a link with class "row-action"
	delegate.on('click', 'tr:has(.row-action)', function(event) {
		const avoid = '.row-action, a, button, input, select, textarea';

		if (!event.target.matches(avoid) && event.target.closest(avoid) === null) {
			const action = event.target.closest('tr').querySelector('.row-action');
			if (action) action.click();
		}
	});


	// Gift cards
	document.querySelectorAll('.ProductForm__GiftCardFields--is_a_gift input').forEach(checkbox => {
		checkbox.addEventListener('change', event => {
			event.target.closest('.ProductForm__GiftCardFields').querySelectorAll('.Form__Item').forEach(item => {
				item.hidden = !checkbox.checked;
			});
		});
		window.addEventListener('pageshow', event => {
			checkbox.dispatchEvent(new Event('change'));
		});
	});



	// cart:refresh - triggers when the cart is refreshed
	// breakpoint:changed - triggers when switching between mobile/tablet/laptop/desktop
	// variant:changed - triggers when changing variant on the product page
	// theme:loading:start - triggers when something starts to load
	// theme:loading:end - triggers when something finishes loading
	// product:added - triggered when product added to cart
	// model:played - triggers when product media play started
	// model:paused - triggers when product media play paused
	// video:played - triggers when product video play started
	// video:paused - triggers when product video play paused
	// scrollspy:target:changed - triggered when there is a change of visibility
	// product:changed - triggered by Shop The Look when a product changes

	

})();